import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGlobeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 23 23"
    {...props}
  >
    <path
      fill="#787887"
      d="M11.833.74c6.101 0 11.044 4.942 11.044 11.043s-4.943 11.044-11.044 11.044C5.733 22.827.79 17.884.79 11.783.79 5.683 5.732.74 11.833.74m7.971 7.124a8.96 8.96 0 0 0-4.408-4.185c.623 1.157 1.113 2.582 1.425 4.185zm-7.97-4.987c-.847 0-2.183 1.87-2.85 4.988h5.655c-.668-3.118-2.004-4.988-2.806-4.988m-8.907 8.906c0 .624.045 1.247.178 1.782h3.429c-.045-.58-.045-1.158-.045-1.782 0-.579 0-1.158.045-1.781H3.105a8 8 0 0 0-.178 1.781m.89 3.919a9.05 9.05 0 0 0 4.41 4.23c-.624-1.157-1.114-2.582-1.426-4.23zm2.984-7.837c.312-1.604.802-3.029 1.425-4.186a8.96 8.96 0 0 0-4.408 4.185zm5.032 12.824c.802 0 2.138-1.825 2.806-4.987H8.983c.668 3.162 2.004 4.987 2.85 4.987m3.117-7.124c.045-.535.09-1.158.09-1.782 0-.623-.045-1.202-.09-1.781H8.672c-.045.579-.045 1.158-.045 1.781 0 .624 0 1.247.045 1.782zm.446 6.368a9.05 9.05 0 0 0 4.408-4.231h-2.983c-.312 1.648-.802 3.073-1.425 4.23m1.692-6.368h3.473c.09-.535.178-1.158.178-1.782 0-.579-.089-1.202-.178-1.781h-3.473c.044.623.089 1.202.089 1.781 0 .624-.044 1.203-.09 1.782"
    />
  </svg>
);
export default SvgGlobeIcon;
